import React from 'react';
import { browserHistory } from 'react-router';

const page = ['order-history', 'myaccount'];

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(redirectPage) {
    browserHistory.push(`${this.props.link}/${redirectPage}`);
    this.props.toggle();
  }

  render() {
    return !this.props.auth.authenticated ? (
      <ul>
        <li>
          <a className="olo-client-theme-color" onClick={this.props.signIn}>
            <i className="fa fa-sign-in" /> Sign In
          </a>
        </li>
      </ul>
    ) : (
      <ul className={page.includes(this.props.page) ? 'active-menu' : ''}>
        <li className={this.props.page === page[0] ? 'active-sub-menu' : ''}>
          <a className="olo-client-theme-color" onClick={() => this.handleClick(page[0])}>Order History</a>
        </li>
        <li className={this.props.page === page[1] ? 'active-sub-menu' : ''}>
          <a className="olo-client-theme-color" onClick={() => this.handleClick(page[1])}>Acctount Setting</a>
        </li>
        <li>
          <a className="olo-client-theme-color" onClick={this.props.signIn}>
            <i className="fa fa-sign-out" /> Sign Out
          </a>
        </li>
      </ul>
    );
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/views/menu/components/Settings.jsx